import { Component, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpParams } from '@angular/common/http';
import { AppService } from '../../services/app.service';

@Component({
    selector: 'app-scheme-preview',
    templateUrl: './scheme-preview.component.html',
    styleUrls: ['./scheme-preview.component.scss'],
})
export class SchemePreviewComponent {
    @Input()
    public primaryScheme: string;

    constructor(private appService: AppService) {}

    public schemeDownloadUrl(schemeId: string, preview?: boolean) {
        const params = new HttpParams({
            fromObject: {
                utm_source: 'quote-assist',
                ...(preview && { type: 'preview' }),
                ...this.appService.getLanguageCountry(),
            },
        });
        return `${environment.http.pim.baseUrl}schemes/${schemeId}?${params.toString()}`;
    }
}
